module.exports = __webpack_public_path__ + "img/1x.9232c96.jpg";